import { AreaEntity } from "../entities/area.entity";

export abstract class AreaRepository {
    public abstract getById(enterpriseSiteId: string): Promise<AreaEntity>;
}
